import authStore from '../store/modules/auth';

export default function authHeader() {
	if (authStore.getters.isLoggedIn) {
		return `Bearer ${authStore.state.accessToken}`;
	} else {
		return 'No Token';
	}
}
